import { ORIGIN, YML_FILE_NAME } from './const';

export function truncate(str = '', length: number): string {
  return str.length > length ? `${str.substr(0, length)}...` : str;
}

export function getRefPageURL(
  repoPath: string,
  refType = 'branch',
  refName = 'master',
  revision = '',
  line?: number
): string {
  const bitbucketRepositoryUrl = `${ORIGIN}/${repoPath}`;
  const referenceType = refType ? refType.toLowerCase() : '';

  if (referenceType === 'branch' || referenceType === 'named_branch') {
    return `${bitbucketRepositoryUrl}/commits/branch/${encodeURIComponent(
      refName
    )}`;
  } else if (referenceType === 'custom') {
    const configurationFileUrl = `${bitbucketRepositoryUrl}/src/${encodeURIComponent(
      revision
    )}/${YML_FILE_NAME}`;
    if (line) {
      return `${configurationFileUrl}?fileviewer=file-view-default#${YML_FILE_NAME}-${line}`;
    }
    return configurationFileUrl;
  } else {
    return `${bitbucketRepositoryUrl}/commits/tag/${encodeURIComponent(
      refName
    )}`;
  }
}

export function formatDuration(seconds: number): string {
  const totalSeconds = parseInt(`${seconds}`, 10);
  const hours = Math.floor(totalSeconds / 3600);

  let remainingSeconds = totalSeconds % 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  remainingSeconds %= 60;

  const prettyHoursWithSeparator =
    hours > 1 ? `${hours}hrs` : hours === 1 ? `${hours}hr` : '';
  const prettyMinutes = minutes ? `${minutes}min` : '';

  return `${prettyHoursWithSeparator} ${prettyMinutes} ${remainingSeconds} sec`.trim();
}
